/* eslint-disable import/prefer-default-export */
export const getFirstLetters = (name) => {
    if (name) {
        const nameArray = name.split(' ');
        const firstLetters = nameArray.map((item) => [...item][0]);
        return firstLetters;
    }
    return null;
};
